import React, { useEffect, useState } from "react";  
 
import Header from 'components/Dashboard/Header'  
import SubscriptionExpiredModal from 'components/SubscriptionExpiredModal';
import SubscriptionLoading from 'components/SubscriptionLoading';
import useSubscriptionCheck from 'hooks/useSubscriptionCheck';
  
import { 
    DashboardPage,
    DashboardBody,
    DashboardBodyContent,
    Content
} from "./styled";
import { ReadObject } from "services/storage";
import { useHistory } from "react-router-dom";

export default function ContainerAuthenticated({ children, primary, page }){  

    const history = useHistory();
    const navigate = to => history.push(`/${ to }`);
    
    // Verificação de assinatura
    const { hasActiveSubscription, loading: subscriptionLoading, subscriptionData } = useSubscriptionCheck();
    const [showSubscriptionModal, setShowSubscriptionModal] = useState(false);

    const init = () => {
        const authentication = ReadObject('authentication')
        if (!authentication?.jwt) {
            completeNext()
        }
    }
 
    const completeNext = () => {
        navigate('login')
    }

    // Verificar se deve mostrar modal de assinatura expirada
    useEffect(() => {
        // Páginas que NÃO devem verificar assinatura (página de conta, planos, etc.)
        const exemptPages = ['account', 'plans', 'sign'];
        const currentPath = window.location.pathname;
        const isExemptPage = exemptPages.some(exemptPage => currentPath.includes(exemptPage));
        
        if (!subscriptionLoading && hasActiveSubscription === false && !isExemptPage) {
            setShowSubscriptionModal(true);
        } else {
            setShowSubscriptionModal(false);
        }
    }, [hasActiveSubscription, subscriptionLoading]);

    useEffect(() => {  
        init() 
    }, [])

    return ( 
        <>
            <Content>
                <DashboardPage>
                    <Header page={page} /> 
                    <DashboardBody> 
                        <DashboardBodyContent primary={primary}>                     
                            { children }
                        </DashboardBodyContent>
                    </DashboardBody>  
                </DashboardPage> 
            </Content>
            
            {/* Loading durante verificação de assinatura */}
            {subscriptionLoading && (
                <SubscriptionLoading message="Verificando sua assinatura..." />
            )}
            
            {/* Modal de assinatura expirada */}
            {showSubscriptionModal && (
                <SubscriptionExpiredModal 
                    isOpen={showSubscriptionModal}
                    title="Acesso Restrito"
                    message="Parece que sua assinatura expirou ou foi cancelada. Renovando, você volta a usar os recursos do TiqChat. Qualquer dúvida, entre em contato com a gente pelo WhatsApp 92 98216-8732" 
                />
            )}
        </>
    );
}